angular.module('AccountingBoxApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('app.bookkeeper.admin', {
        url: '/admin',
        abstract: false,
        // templateUrl: 'app/admin/admin.html',
        template: "<div class='react-hybrid bookkeeper'><react-app/></div>",
        // controller: 'AdminCtrl'
      })
  .state('app.bookkeeper.admin.generalLedger', {
      url: '/general-ledger',
      template: ''
    })
      .state('app.bookkeeper.admin.companyFinancials', {
        url: '/company-financials',
        template: ''
      });
  });
